import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";
if (environment.production) {
  enableProdMode();
}

if (environment.etrackerCode) {
  const script = document.createElement("script");
  script.id = "_etLoader";
  script.type = "text/javascript";
  script.charset = "UTF-8";
  script.dataset.blockCookies = "true";
  script.dataset.pageChangedDetection = "url";
  (script as any)["style"] = "display:none";
  script.dataset.secureCode = environment.etrackerCode;
  script.src = "//code.etracker.com/code/e.js";
  script.async = true;
  document.head.appendChild(script);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
